module.exports = __webpack_public_path__ + "img/s-Front-Contour-Reference4.0fc3a5a8.png";